
// @ts-nocheck


export const localeCodes =  [
  "en",
  "da",
  "de",
  "es",
  "fi",
  "fr-CA",
  "fr-FR",
  "it",
  "nl",
  "no",
  "pt-BR",
  "pt-PT",
  "sv"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_134999af",
      load: () => import("#nuxt-i18n/134999af" /* webpackChunkName: "locale_en_46json_134999af" */),
      cache: true
    }
  ],
  da: [
    {
      key: "locale_da_46json_e5b5f78b",
      load: () => import("#nuxt-i18n/e5b5f78b" /* webpackChunkName: "locale_da_46json_e5b5f78b" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_43eef579",
      load: () => import("#nuxt-i18n/43eef579" /* webpackChunkName: "locale_de_46json_43eef579" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_617cfe60",
      load: () => import("#nuxt-i18n/617cfe60" /* webpackChunkName: "locale_es_46json_617cfe60" */),
      cache: true
    }
  ],
  fi: [
    {
      key: "locale_fi_46json_5018e306",
      load: () => import("#nuxt-i18n/5018e306" /* webpackChunkName: "locale_fi_46json_5018e306" */),
      cache: true
    }
  ],
  "fr-CA": [
    {
      key: "locale_fr_45CA_46json_4b6e35f6",
      load: () => import("#nuxt-i18n/4b6e35f6" /* webpackChunkName: "locale_fr_45CA_46json_4b6e35f6" */),
      cache: true
    }
  ],
  "fr-FR": [
    {
      key: "locale_fr_45FR_46json_087c3a03",
      load: () => import("#nuxt-i18n/087c3a03" /* webpackChunkName: "locale_fr_45FR_46json_087c3a03" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_8aab6d6f",
      load: () => import("#nuxt-i18n/8aab6d6f" /* webpackChunkName: "locale_it_46json_8aab6d6f" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_f8a8dd65",
      load: () => import("#nuxt-i18n/f8a8dd65" /* webpackChunkName: "locale_nl_46json_f8a8dd65" */),
      cache: true
    }
  ],
  no: [
    {
      key: "locale_no_46json_c323b956",
      load: () => import("#nuxt-i18n/c323b956" /* webpackChunkName: "locale_no_46json_c323b956" */),
      cache: true
    }
  ],
  "pt-BR": [
    {
      key: "locale_pt_45BR_46json_ba5c4963",
      load: () => import("#nuxt-i18n/ba5c4963" /* webpackChunkName: "locale_pt_45BR_46json_ba5c4963" */),
      cache: true
    }
  ],
  "pt-PT": [
    {
      key: "locale_pt_45PT_46json_f183360d",
      load: () => import("#nuxt-i18n/f183360d" /* webpackChunkName: "locale_pt_45PT_46json_f183360d" */),
      cache: true
    }
  ],
  sv: [
    {
      key: "locale_sv_46json_7fa5c901",
      load: () => import("#nuxt-i18n/7fa5c901" /* webpackChunkName: "locale_sv_46json_7fa5c901" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "da",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/da.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/es.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fi",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/fi.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr-CA",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/fr-CA.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr-FR",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/fr-FR.json",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/it.json",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/nl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "no",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/no.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt-BR",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/pt-BR.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt-PT",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/pt-PT.json",
          cache: undefined
        }
      ]
    },
    {
      code: "sv",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/sv.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "locales/",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "en",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "da",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/da.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fi",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/fi.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr-CA",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/fr-CA.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr-FR",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/fr-FR.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/it.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/nl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "no",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/no.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt-BR",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/pt-BR.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt-PT",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/pt-PT.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sv",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview-nuxt-apps/apps/clientportal/i18n/locales/sv.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/